import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React,{ useEffect } from 'react'


const DialogBox = ({ open, handleClose, handleSumbit, title, modual, customeTitel }) => {
    useEffect(() => {
        if (modual === "materialMasters") {
            if(open){
                document.addEventListener("keydown", function (event) {
                    if (event.key === "Enter") {
                      event.preventDefault();
                      handleSumbit();
                  }
              });
            }
        }
    }, [open])
    

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {customeTitel ? customeTitel : `Are you sure, want to ${title} ?`}
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleSumbit}>Yes</Button>
                <Button onClick={handleClose} >
                    No
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogBox